// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"6b9acff3","929":"b19cd26c"}[chunkId] + ".chunk.js";
};